var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vx-row"},[_c('div',{staticClass:"vx-col w-full mb-sub-title"},[_c('vx-card',{staticClass:"sub-title-card"},[_c('h1',{staticClass:"rg-sub-title extrabold"},[_vm._t("default")],2)])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }